import React from "react";
import { Box, Container, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import HeroPage from "./Setup/HeroPage";
import Problem from "./Setup/Problem";
import ConnectingPage from "./Setup/ConnectingPage";
import GoingBeyond from "./Setup/GoingBeyond";
import BeforeFooter from "./Setup/BeforeFooter";
import Features from "./Setup/Features";
import Feature from "./Setup/Feature";
import Footer from "./Setup/Footer";
import Benefits from "./Setup/Benefits";

function UlapRecruit() {
    return (
        <>
            <HeroPage/>
            {/* <Problem/> */}
            <ConnectingPage/>
            {/* <Features/> */}
            <Feature/>
            {/* <GoingBeyond/> */}
            <Benefits/>
            <BeforeFooter/>
            <Footer/>
        </>

        
    )
}

export default UlapRecruit
